import {getAllJobsString, getTaskBoardJobs, updateJobAdmin} from "../../service/JobService";
import {isTaskJob} from "./schedulerUtils";
import {buildTaskAdminPayload, buildTaskFormFromJob} from "./taskFormUtils";

export const DEFAULT_SCHEDULER_WORKER_ID = "3";
export const CLEANING_BOARD_MODE = "cleaning";
export const TASK_BOARD_MODE = "task";

export const cleaningStatusOptions = [
    {label: "Pending", value: "Pending", variant: "outline-dark"},
    {label: "Important", value: "Updated", variant: "outline-danger", countKey: "Updated"},
    {label: "Scheduled", value: "Scheduled", variant: "outline-primary"},
    {label: "InProgress", value: "InProgress", variant: "outline-warning"},
    {label: "ReadyForBilling", value: "ReadyForBilling", variant: "outline-success"},
    {label: "Cancelled", value: "Cancelled", variant: "outline-secondary"},
    {label: "X", value: "ALL", variant: "outline-dark"},
];

export const taskStatusOptions = [
    {label: "Pending (No Date)", value: "Pending", variant: "outline-dark"},
    {label: "Pending (With Date)", value: "PendingWithDate", variant: "outline-dark"},
    {label: "Scheduled", value: "Scheduled", variant: "outline-primary"},
    {label: "ReadyForBilling", value: "ReadyForBilling", variant: "outline-success"},
    {label: "X", value: "ALL", variant: "outline-dark"},
];

export function taskStatusKey(job) {
    if (job.status === "Pending" && job.date) {
        return "PendingWithDate";
    }

    return job.status;
}

export function matchesTaskStatus(job, selectedStatus) {
    return selectedStatus === "ALL" || taskStatusKey(job) === selectedStatus;
}

export function shouldShowOnTaskBoard(job) {
    if (!isTaskJob(job)) {
        return false;
    }

    switch (job.status) {
        case "Pending":
            return true;
        case "Scheduled":
        case "ReadyForBilling":
            return true;
        default:
            return false;
    }
}

export function shouldShowTaskOnWorkerLane(job, {selectedDate} = {}) {
    if (!isTaskJob(job) || job.status !== "ReadyForBilling") {
        return true;
    }

    return Boolean(selectedDate && job?.date && String(job.date) === String(selectedDate));
}

export const cleaningBoardConfig = {
    mode: CLEANING_BOARD_MODE,
    defaultStatus: "Pending",
    defaultWorkerId: DEFAULT_SCHEDULER_WORKER_ID,
    usesSelectedDate: true,
    statusStorageKey: "schedulerCleaningStatus",
    workerStorageKey: "schedulerCleaningWorkerId",
    legacyStatusStorageKey: "radioValue",
    statusOptions: cleaningStatusOptions,
    emptyMessage: "No Job available on Current Date and Filter",
    fetchJobs: (selectedDate) => getAllJobsString(selectedDate, selectedDate),
    filterJobs: (jobs = []) => jobs,
    filterWorkerJobs: shouldShowTaskOnWorkerLane,
};

export const taskBoardConfig = {
    mode: TASK_BOARD_MODE,
    defaultStatus: "Pending",
    defaultWorkerId: DEFAULT_SCHEDULER_WORKER_ID,
    usesSelectedDate: false,
    statusStorageKey: "schedulerTaskStatus",
    workerStorageKey: "schedulerTaskWorkerId",
    statusOptions: taskStatusOptions,
    matchesStatus: matchesTaskStatus,
    statusKey: taskStatusKey,
    emptyMessage: "No Task available for the current filter",
    fetchJobs: () => getTaskBoardJobs(),
    filterJobs: (jobs = []) => jobs.filter(shouldShowOnTaskBoard),
    assignWorker: (job, workerId, {selectedDate}) => {
        return updateJobAdmin(buildTaskAdminPayload({
            ...buildTaskFormFromJob(job),
            cos_job_worker: workerId,
            date: selectedDate || job?.date || "",
        }));
    },
    filterWorkerJobs: shouldShowTaskOnWorkerLane,
};
